import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/ringFinger'
import { thumbEmbroideryDrawer, thumbEmbroideryDrawerForUsAtoms } from 'src/features/brands/atoms/canvas/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndWristBeltForErmWrist, thumbOut } from '../thumbAndListBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfErmWrist, edgeOfWrist } from '../edge/edgeOfWrist'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'
import { thumbAndListBeltOfUsModel, thumbOutOfUsModel, thumbOverPartsUpperOfUsModel } from '../thumbAndListBeltOfUsModel'
import { hamidashiOfUsAtoms, thumbWeltingOfUsAtoms } from '../hamidashi/usAtoms'
import { littleFingerLeftForUs, littleFingerRightForUs } from '../littleFingerOfUsModel'
import { seriesChecker, usModelOfAtomsChecker } from 'src/features/brands/atoms/helper'
import { middleFingerCover } from '../fingerCoverOrPad/middleFingerCover'
import { ermBelt } from '../ermBelt'
import { thumbHook } from '../hooks/thumbHook'

// 通常ベルトモデル
export const beltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerCover = ['middleCover'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const stitchColor = state.stitch.color
  const bindingColor = state.edge.color

  // 親指指袋_手口ベルト(下地)
  thumbAndWristBeltForErmWrist(ctx, state.thumbWeb?.color, stitchColor)
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外

  indexFingerRight(ctx, state, needCatchFaceWrap) // 人差し指＿右... UBackここで描いてる
  const { is2025Agl, is2025Apl, isDefaultWristBelt } = seriesChecker(state.baseModel.productNumber)
  if (isDefaultWristBelt) {
    listBelt(ctx, state.listBelt?.color, stitchColor)
  } else if (is2025Apl && !is2025Agl) {
    ermBelt(ctx, state.listBelt.color, stitchColor)
  }
  indexFingerLeft(ctx, state.indexMiddle?.color) //人差し指＿左
  middleFingerRight(ctx, state.middleIndex?.color) // 中指＿右
  middleFingerLeft(ctx, state.middleRing?.color) // 中指＿左
  ringFingerRight(ctx, state.ringMiddle?.color) // 薬指＿右
  ringFingerLeft(ctx, state.ringLittle?.color) // 薬指＿左

  // 小指
  littleFingerRight(ctx, state.littleRing?.color)
  littleFingerLeft(ctx, state.littleOut?.color)
  hamidashiOfNormal(ctx, state.hamidashi?.color)

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, stitchColor, needCatchFaceWrap)
  edgeOfBeltBackStyle(ctx, state.edge?.color, stitchColor) // ヘリ革

  if (isDefaultWristBelt) {
    edgeOfWrist(ctx, bindingColor, stitchColor) // 投手用 && AGL
  } else {
    edgeOfErmWrist(ctx, bindingColor, stitchColor) // これ変える
  }

  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, stitchColor) // 指当て(人指し指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, stitchColor, -165, 90, -15) // 指当て(中指)
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch) // 指股
  isMiddleFingerCover && middleFingerCover(ctx, state.indexCover.color, stitchColor, -165, 90, -15) // 指カバー(中指)
  thumbHook(ctx, state.thumbHook.color, 110, -310, 15) // 先端 // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color, -14, 30, 0) //手元

  thumbEmbroideryDrawer(ctx, state.embroideries) // 親指への刺繍

  ctx.fillStyle = '#ffffff'
  ctx.beginPath()
  ctx.arc(327, 516, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.arc(344, 560, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// 通常ベルトモデル
export const usBeltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  const isUsModelOfAtoms = usModelOfAtomsChecker(state.baseModel.productNumber)
  if (!isUsModelOfAtoms) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerCover = ['middleCover'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const stitchColor = state.stitch.color
  const bindingColor = state.edge.color
  const weltingColor = state.hamidashi.color

  // 親指指袋_手口ベルト(下地)
  // ここでUS専用の描画
  thumbAndListBeltOfUsModel(ctx, state.thumbRoot?.color)
  thumbOutOfUsModel(ctx, state.thumbOut?.color) // 親指＿外
  thumbOverPartsUpperOfUsModel(ctx, state.thumbWeb?.color)
  indexFingerRight(ctx, state, needCatchFaceWrap) // 人差し指＿右... UBackここで描いてる
  indexFingerLeft(ctx, state.indexMiddle?.color) // 人差し指＿左
  middleFingerRight(ctx, state.middleIndex?.color) // 中指＿右
  middleFingerLeft(ctx, state.middleRing?.color) // 中指＿左
  ringFingerRight(ctx, state.ringMiddle?.color) // 薬指＿右
  ringFingerLeft(ctx, state.ringLittle?.color) // 薬指＿左

  // 小指
  const isAJK05 = state.baseModel.productNumber === 'AJK-05'
  if (isAJK05) {
    littleFingerRight(ctx, state.littleRing?.color)
    littleFingerLeft(ctx, state.littleOut?.color)
    hamidashiOfNormal(ctx, weltingColor)
    thumbWeltingOfUsAtoms(ctx, weltingColor)
  } else {
    // ここでUS専用の描画
    littleFingerRightForUs(ctx, state.littleRing.color)
    littleFingerLeftForUs(ctx, state.littleOut.color)
    hamidashiOfUsAtoms(ctx, weltingColor)
  }
  catchFace2(ctx, state.catchFace?.color, stitchColor, needCatchFaceWrap) // 捕球面 / ウェブ下折り返し
  edgeOfBeltBackStyle(ctx, bindingColor, stitchColor) // ヘリ革
  edgeOfWrist(ctx, bindingColor, stitchColor) // ヘリ革

  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, stitchColor) // 指当て(人指し指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, stitchColor, -165, 90, -15) // 指当て(中指)
  fingerCrotch(ctx, state.catchFace.color, weltingColor, state.baseModel.isFingerCrotch)
  isMiddleFingerCover && middleFingerCover(ctx, state.indexCover.color, stitchColor, -165, 90, -15) // 指カバー(中指)
  thumbEmbroideryDrawerForUsAtoms(ctx, state.embroideries)
}
